import React from "react";
import { useForm } from "react-hook-form";

import { AppModal } from "components/AppModal";
import { User } from "models/user";
import { TextField } from "components/TextField";
import { ReactComponent as LockIcon } from "assets/images/svg/lock.svg";
import { AppButton } from "components/AppButton";

import { UsersResetPasswordData } from "services/api/UsersApi";

import styles from "./UsersResetPassword.module.scss";

interface Props {
  onClose(): void;
  user: User;
  disabled: boolean;
  onSubmit(values: UsersResetPasswordData): void;
}

export const UsersResetPassword: React.FC<Props> = ({
  onClose,
  onSubmit,
  disabled,
  user,
}) => {
  const [passVisible, setPassVisible] = React.useState(false);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<UsersResetPasswordData>({});
  return (
    <AppModal onClose={onClose} title={`Сбросить пароль для ${user.phone}`}>
      <form className={styles.container} onSubmit={handleSubmit(onSubmit)}>
        <TextField
          {...register("password", {
            required: "Введите пароль",
            minLength: {
              value: 8,
              message: "Минимум 8 символов",
            },
          })}
          type={passVisible ? "text" : "password"}
          label="Пароль"
          icon={
            <LockIcon
              onClick={() => {
                setPassVisible((prev) => !prev);
              }}
            />
          }
          withError
          error={errors.password}
        />
        <AppButton disabled={disabled} type="submit">
          Сбросить
        </AppButton>
      </form>
    </AppModal>
  );
};
